import { useState } from "react";
import axios from "axios";

import Input from '@/components/Input';
import Button from '@/components/Button';
import LanguageIcon from '@mui/icons-material/Language';
import { getErrorMessage } from '@/utils/Errors';
import { getParametersURL } from '@/utils/URL';

export default function Login({t,language,apiUrl,sendMessage,setShowLanguage,handleLogin}){

	const [ params ] = useState(getParametersURL());

	// check if coming by get parameter
	const [ data, setData ] = useState({
        email: params?.email ? params.email : null,
        password: params?.password ? params.password : null
    });

	const changeLanguage = () => {
        setShowLanguage(true);
    };

	const handleInput = (e) => {

        var name = e.target.name;
        var value = e.target.value;

        if(name === 'email'){
        	setData({email:value,password:data?.password});
        }
        else{
        	setData({email:data?.email,password:value});
        }
    };

    // submit with enter
    const handleKeyDown = (e) => {
		if (event.key === 'Enter') {
			handleSubmit(e);
		}
	}

	const handleSubmit = () => {

        if(data?.email && data.email.length > 0 && data?.password && data.password.length > 0){

        	const send = {
        		language: language,
        		email: data?.email,
        		password: data?.password
        	};

        	if(params?.company){
        		send.companyuser = params.company;
        	}

            axios.post(apiUrl + "/login",send)
            .then(function (response) {

                if(
                    response?.data && 
                    response.data?.result && 
                    response.data?.data && 
                    response.data.data?.token &&
                    response.data.data?.user
                ){
              
                    const data = response.data;
                    const token = data.data.token;
                    const user = data.data.user;
                    
                    handleLogin(token,user);
                    return;
                }
                else{
                    sendMessage(t('login.error'),'error');                    
                    handleLogin(null);
                }
            })
            .catch(function(){
                //sendMessage(error.message,'error');
                sendMessage(t('login.error'),'error');        
                handleLogin(null);
            });
        }
        else{                                    
            sendMessage(t('login.errors.empty'),'error');
        }
    }

	// forgot password
	const handleForgot = () => {

		const email = data?.email;

		if(!email || email.length === 0){
			sendMessage(t('login.forgot.errors.emptyemail'),'error');
		}
		else{
			
			const apiPath = '/forgot';

			const config = {
	            //headers: {},   
	            // params is the same as using ?database=, query params      
	            params: {
	                language: language,
	                email: email
	            }  
	        };

            var errorMessage = t('login.forgot.error');
            const url = apiUrl+apiPath;
            
            axios.get(url,config)
            .then(function (response) {
                    
                if(response?.data){
              
                    var responseData = response.data;

                    // if result is ok (1)                
                    if(responseData?.result){              
                        sendMessage(t('login.forgot.emailsent'));
                    } 
                    else{

                        // check error message
                        if(responseData?.data?.reasons){                           	
                        	errorMessage = getErrorMessage(t,'login.forgot',responseData?.data?.reasons,false,false);
                        }
                        
                        sendMessage(errorMessage,'error');                        
                    }
                }
                else{
                    sendMessage(errorMessage,'error');   
                }
            })
            .catch(function (error){
            	if(error){
                	sendMessage(errorMessage,'error');                
                }
            });
		}
	}

 	return (
    	<div id='login-page'>
	        
	        <div id='login-box'>

	        	<div className='text-end pt-1 pe-1'>
			        <Button 
			        	sx={{padding:1,color:'white',border:0}} 
			        	onClick={changeLanguage}
	                	icon={<LanguageIcon/>}
	                />
	            </div>

		        <div className="text-center pt-16">
		         	<img		         	
		            	alt="VIGEPRA"
		            	src="/images/logo.png"
		            	className="mx-auto w-40 md:w-48 lg:w-56"
		          	/>
		        </div>		        

		        <div id="login-form">
		          
		          	<form className=''>
		            	
		            	<div>
		              		<div className="mt-2">             			
			                	<Input	     
				                	className='login-input'               
				                    name="email"
				                    type="email"
				                    value={data?.email}	                    
				                    placeholder={t('login.email')}
				                    autoComplete="email"
				                    onChange={handleInput}
				                    error=''
				        			handleKeyDown={handleKeyDown}
				        			variant='filled'
			                	/>
		              		</div>
		            	</div>

		            	<div>
		              
		              		<div className="mt-6">		              			
		                		<Input	             
				                	className='login-input'       
				                    name="password"
				                    type="password"
				                    value={data?.password}	                    
				                    placeholder={t('login.password')}
				                    autoComplete="password"
				                    onChange={handleInput}
				                    error=''
				        			handleKeyDown={handleKeyDown}
				        			variant='filled'
		                		/>			                	
		              		</div>		              		

		            	</div>

		            	<div className="text-end text-white mt-2">
				                				                
		                 	<a onClick={handleForgot} id="login-forgot">
		                   		{t('login.forgot.link')}
		                  	</a>				        
				                
			            </div>

		            	<div className='text-center mt-8'>		            		
		              		<Button
		                		type="login"
		                		text={t("login.submit")}
		                		onClick={handleSubmit}
		              		/>			              	
		            	</div>

		          	</form>

		        </div>
	      	</div>
    	</div>
  )
}
